import React from 'react';
import { ScrollReveal } from './ui/ScrollReveal';
import { SparklesIcon, CheckSquareIcon, SquareIcon } from 'lucide-react';
interface OrderBumpProps {
  isChecked: boolean;
  onToggle: () => void;
}
export function OrderBump({
  isChecked,
  onToggle
}: OrderBumpProps) {
  return <ScrollReveal data-id="element-93">
      <div id="oferta-especial" className={`mt-12 p-6 rounded-2xl border-2 border-dashed transition-all duration-300 cursor-pointer
          ${isChecked ? 'bg-amber/10 border-amber shadow-md' : 'bg-white border-brown/20 hover:border-amber/50'}`} onClick={onToggle} data-id="element-94">
        <div className="flex items-center gap-2 mb-4" data-id="element-95">
          <SparklesIcon className="w-6 h-6 text-amber animate-pulse" data-id="element-96" />
          <h3 className="font-bold text-brown text-lg" data-id="element-97">
            🎯 ¡OFERTA ESPECIAL PARA HOY!
          </h3>
        </div>

        <div className="flex flex-col md:flex-row items-start gap-5" data-id="element-98">
          <div className="w-full md:w-48 shrink-0" data-id="element-99">
            <img src="https://cdn.magicpatterns.com/uploads/8jFpSWXkVV7cTAhx2iAxFH/ORDER_BUMP.png" alt="Kit del Sueño Profundo - El Reposo del Guerrero" className="w-full rounded-xl shadow-lg border border-amber/20" data-id="element-100" />
          </div>

          <div className="flex-1" data-id="element-101">
            <div className="flex items-start gap-3 mb-2" data-id="element-102">
              <div className="mt-1 shrink-0" data-id="element-103">
                {isChecked ? <CheckSquareIcon className="w-7 h-7 text-forest" data-id="element-104" /> : <SquareIcon className="w-7 h-7 text-brown/40" data-id="element-105" />}
              </div>
              <p className="font-bold text-lg text-brown" data-id="element-106">
                SÍ, AGREGAR EL "KIT DEL SUEÑO PROFUNDO" (+ $7.500 ARS)
              </p>
            </div>
            <p className="text-brown/80 font-sans text-sm md:text-base leading-relaxed mb-3 ml-10 md:ml-0" data-id="element-107">
              ¿Te cuesta apagar la cabeza por el estrés económico? Sumá esta
              guía exclusiva para{' '}
              <strong className="text-forest" data-id="element-108">dormir 8 horas de corrido</strong>{' '}
              usando solo 3 plantas que tenés en tu alacena. Evitá las pastillas
              químicas y despertate con energía real.
            </p>
            <p className="text-sm font-medium ml-10 md:ml-0" data-id="element-109">
              <span className="text-brown/50 line-through mr-2" data-id="element-110">
                Precio normal $14.000
              </span>
              <span className="text-forest font-bold bg-forest/10 px-2 py-1 rounded" data-id="element-111">
                Solo $7.500 extra hoy
              </span>
            </p>
          </div>
        </div>
      </div>
    </ScrollReveal>;
}